import angular from "angular";

import VtSharedModule from '../../../vt-shared/vt-shared.module';
import ServiceProviderModuleRouting from './service-provider-root.module.routing';
import ServiceProviderRootComponent from "./service-provider-root.component";
import ServiceProviderContactUsApi from '../../resources/contact-us/service-provider-contact-us.resource';

export default angular.module("vt-service-provider-root.module", [
  VtSharedModule.name,
  ServiceProviderContactUsApi.name
])
  .config(ServiceProviderModuleRouting)
  .component("serviceProviderPage", ServiceProviderRootComponent);
